import { takeLatest, call, put } from "redux-saga/effects"
import axios from "axios"
import { message } from "antd"

import { push } from "connected-react-router"
import {
  GET_AMBASSADORS_SUMMARY_WATCHER,
  UPLOAD_TEMPLATE_AMBASSADORS_WATCHER,
  SAVE_EXCEL_AMBASSADORS_WATCHER,
  GET_LANGUAGE_WATCHER,
} from "./constants"

import {
  getAmbassadorsSummarySuccess,
  getAmbassadorsSummaryFailed,
  uploadTemplateAmbassadorsFailed,
  uploadTemplateAmbassadorsSuccess,
  saveExcelAmbassadorsProgress,
  saveExcelAmbassadorsSuccess,
  getLanguageFailed,
  getLanguageSuccess,
} from "./actions"
import { LOCAL_TOKEN } from "../../utils/storage"

function messageProgress(messagex) {
  message.loading(messagex, 0)
}

function messageSuccess(messagex) {
  message.success(messagex, 5)
}

function messageFailed(messagex) {
  message.error(messagex, 5)
}

function messageDestroy() {
  message.destroy()
}

// GET LANGUAGE
export function getLanguageApi() {
  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}language/`,
  })
}
export function* getLanguageSaga() {
  try {
    const {
      data: { data },
    } = yield call(getLanguageApi)

    yield put(getLanguageSuccess(data))
  } catch (error) {
    yield put(getLanguageFailed())
    returnMessage(error)
  }
}

// GET SUMMARY
function getAmbassadorsSummaryApi() {
  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}ambassadors/import/xlsx/summary`,
  })
}

function* getAmbassadorsSummary(action) {
  try {
    const { data, status } = yield call(getAmbassadorsSummaryApi)
    if (status === 200) {
      yield put(getAmbassadorsSummarySuccess(data.data.result[0].summary))
    }
  } catch (error) {
    returnMessage(error)
    yield put(getAmbassadorsSummaryFailed())
  }
}

// UPLOAD EXCEL
function uploadTemplateAmbassadors(payload) {
  return axios.request({
    method: "post",
    url: `${process.env.API_URL}ambassadors/import/xlsx/`,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    data: payload,
  })
}

function uploadTemplateAmbassadorsProgress(payload) {
  return axios.request({
    method: "get",
    url: `${process.env.API_URL}ambassadors/import/xlsx/progress`,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    params: payload,
    validateStatus: (status) => true, // I'm always returning true,
  })
}

export function* uploadTemplateAmbassadorsWatcher(action) {
  try {
    yield call(messageProgress, "Cargando archivo")
    yield call(uploadTemplateAmbassadors, action.payload)
    let data
    while (true) {
      yield new Promise((resolve) => setTimeout(resolve, 1000))
      data = yield call(uploadTemplateAmbassadorsProgress)
      if (data.status === 200) {
        yield call(getAmbassadorsSummary)
        yield call(messageDestroy)
        returnMessage(data)
        yield put(uploadTemplateAmbassadorsSuccess())
        break
      }
      if (data.status === 500) {
        yield call(messageDestroy)
        message.error(data.data.data.error, 5)
        yield put(uploadTemplateAmbassadorsFailed())
        break
      }
    }
  } catch (error) {
    yield put(uploadTemplateAmbassadorsFailed())
    yield call(messageDestroy)
    yield call(messageFailed, "Error al importar archivo")
  }
}

// SAVE EXCEL
function saveExcelAmbassadorsApi(payload) {
  return axios.request({
    method: "get",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}ambassadors/import/xlsx/confirm?send_invitation=${payload.send_invitation}${payload.id_language?'&id_language='+payload.id_language:''}`,
    validateStatus: (status) => true, // I'm always returning true,
  })
}

function saveExcelAmbassadorsProgressApi() {
  return axios.request({
    method: "get",
    url: `${process.env.API_URL}ambassadors/import/xlsx/confirm/progress`,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    validateStatus: (status) => true, // I'm always returning true,
  })
}

export function* saveExcelAmbassadorsSaga(action) {
  try {
    yield call(saveExcelAmbassadorsApi, action.payload)
    let data
    while (true) {
      yield new Promise((resolve) => setTimeout(resolve, 200))
      data = yield call(saveExcelAmbassadorsProgressApi)
      if (data.status === 202) {
        yield put(
          saveExcelAmbassadorsProgress(data.data.data.result[0].percentage)
        )
      }
      if (data.status === 200) {
        yield put(saveExcelAmbassadorsProgress(100))
        yield put(saveExcelAmbassadorsSuccess(data))
        break
      }
    }
  } catch (error) {
    returnMessage(error)
  }
}

// Individual exports for testing
export default function* ambassadorsSummarySaga() {
  yield takeLatest(SAVE_EXCEL_AMBASSADORS_WATCHER, saveExcelAmbassadorsSaga)
  yield takeLatest(GET_AMBASSADORS_SUMMARY_WATCHER, getAmbassadorsSummary)
  yield takeLatest(
    UPLOAD_TEMPLATE_AMBASSADORS_WATCHER,
    uploadTemplateAmbassadorsWatcher
  )
  yield takeLatest(GET_LANGUAGE_WATCHER, getLanguageSaga)
  // See example in containers/HomePage/saga.js
}
